var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-5"},[(_vm.isAgree === false)?_c('limit-transaction-agree',{on:{"emitResult":_vm.changeAgree}}):[(_vm.step === 1)?_c('limit-transaction2',{on:{"emitResult":_vm.nextStep}}):_vm._e(),(_vm.step === 2)?_c('limit-transaction',{on:{"emitResult":_vm.nextStep}}):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }